import React from 'react'
import { UtilDevice, Bridge, UtilCommon } from '@iskytrip/sdk'
import { LoadingPage } from '../components'
import { AddProductBroseCount } from '@src/api'

export default (WrappedComponent) => {
	class PageEnhance extends WrappedComponent {
		constructor(props) {
			super(props)
			console.log('this._query', this._query)
			this._addProductBroseCount()
			this.state = {
				...(this.state || {}),
				_hideLoadingPage: !!(this._query || {}).hideLoadingPage || !!this._hideLoadingPage,
				hashUrlList: [window.location.href],
				isOnHashChangeEvent: false,
				// _nativeLoading: !!(this._query || {}).nativeLoading || false
			}
		}

		/** life cycle start */
		UNSAFE_componentWillMount() {
			super.UNSAFE_componentWillMount && super.UNSAFE_componentWillMount()
		}

		/**
		 * @description 非app环境唤起pageAppear
		 * @summary 防止子类重写父类方法，因此放pageEnhance
		 * @abstract
		 * @memberof PageEnhance
		 */
		componentDidMount() {
			if (UtilDevice.isApp()) {
				Bridge.appBanRightGestures(this._banRightGestures, (res) => {})
				UtilDevice.setSignalBarColor(this._signalBarColorIsDark, (res) => {})
			} else {
				// 适配小程序,window.location.href方式,页面返回刷新
				if (window && window.history && window.history.replaceState) {
					window.history.replaceState(
						{
							title: '',
							url: window.location.href,
						},
						null,
						'',
					)
				}
				if (window && window.addEventListener) {
					window.addEventListener(
						'popstate',
						() => {
							super.pageAppear && super.pageAppear()
						},
						false,
					)
				}
				// 监听hash值得变化
				if (
					'onhashchange' in window &&
					window.addEventListener &&
					!this.state.isOnHashChangeEvent
				) {
					this.setState({ isOnHashChangeEvent: true })
					window.addEventListener('hashchange', this.bindHashchangeFunc)
				}
			}

			if (this.state._hideLoadingPage) this.hideLoadingPage && this.hideLoadingPage()
			else this.showLoadingPage && this.showLoadingPage()

			this.pageAppear && this.pageAppear()
			super.componentDidMount && super.componentDidMount()
		}

		/**
		 * @description 非app环境唤起pageDisAppear
		 * @summary 防止子类重写父类方法，因此放pageEnhance
		 * @abstract
		 * @memberof PageEnhance
		 */
		componentWillUnmount() {
			this.pageDisAppear && this.pageDisAppear()
			super.componentWillUnmount && super.componentWillUnmount()
			this.state.isOnHashChangeEvent &&
				window.removeEventListener('hashchange', this.bindHashchangeFunc)
			this.setState({ hashUrlList: [], isOnHashChangeEvent: false })
		}
		/** life cycle end */

		/** custom func start */
		showLoadingPage = () => {
			Bridge.airportLoading(true)
			this.setState({ _hideLoadingPage: false })
		}

		hideLoadingPage = () => {
			Bridge.airportLoading()
			this.setState({ _hideLoadingPage: true })
		}
		/** custom func end */

		_addProductBroseCount = () => {
			// 二级分销
			// 进入商品详情页面,如果有这三个值,调用新增产品浏览记录接口
			const retailerCode = UtilCommon.urlQuery('retailerCode') || ''
			const sProductId = UtilCommon.urlQuery('sProductId') || ''
			const sProductType = UtilCommon.urlQuery('sProductType') || ''

			if (retailerCode.length > 0 && sProductId.length > 0 && sProductType.length > 0) {
				let api = new AddProductBroseCount()
				api.setParams({
					productId: sProductId,
					productType: sProductType,
					retailerCode: retailerCode,
				})
				api.execute()
					.then(function(result) {
						if (+result.resultCode === 0) {
							console.log('新增产品浏览记录')
						}
					})
					.catch(function(error) {
						console.error(error)
					})
			}
		}
		bindHashchangeFunc = (event) => {
			const { hashUrlList } = this.state
			const { newURL } = event
			if (hashUrlList.includes(newURL)) uni && uni.navigateBack()

			const newHashUrlList = [...new Set([newURL, ...hashUrlList])]
			this.setState({
				hashUrlList: newHashUrlList,
			})
			this.pageAppear && this.pageAppear()
		}
		render() {
			const { _hideLoadingPage } = this.state

			return (
				<>
					<LoadingPage visible={!_hideLoadingPage} />
					{/* <WrappedComponent
                        {...this.props}
                    /> */}
					{super.render && super.render()}
				</>
			)
		}
		/** life cycle end */
	}

	PageEnhance.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Enhance'
	return PageEnhance
}
